var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 103,
    viewBox: "0 0 200 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.377 9.21712L61.1211 17.0874L70.5445 99L138.801 91.1297L129.377 9.21712Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.966 7.15606L60.6328 14.8046L70.0562 96.7172L136.389 89.0687L126.966 7.15606Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.298 5.24249L57.9648 12.891L67.3882 94.8036L133.721 87.1551L124.298 5.24249Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3003 16.2599L66.0352 18.8271L69.0036 44.6307L91.2688 42.0635L88.3003 16.2599Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40.3749C68 40.3749 68.692 34.5895 73.9375 32.3817C79.183 30.1739 86.6525 29.7495 90.4718 37.7535L91 42.3678L68.5282 45L68 40.3749Z",
    fill: "#0D9F3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4408 24L77 31.7609L81 34L79.4501 26.1044L77.4408 24Z",
    fill: "#F4A28C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M79.5556 27.5252C78.9747 27.4605 78.4338 27.2779 78 27C78.2805 27.8198 78.9953 28.5346 80 29L79.5556 27.5252Z",
    fill: "#CE8172"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.312 23.3325C80.7115 24.5003 80.9428 25.7132 81 26.9387C80.9936 27.0855 80.9563 27.2295 80.8901 27.3625C80.8239 27.4955 80.7303 27.6148 80.6146 27.7134C80.4989 27.812 80.3635 27.888 80.2163 27.9369C80.0691 27.9858 79.9131 28.0066 79.7572 27.9982C79.2562 28.013 78.7613 27.892 78.3314 27.6495C77.9015 27.4071 77.5548 27.0535 77.3327 26.6308L76.2119 24.8982C76.021 24.5291 75.9569 24.1132 76.0285 23.7083C76.1001 23.3034 76.3038 22.9295 76.6114 22.6384C77.6877 21.485 79.9292 22.0017 80.312 23.3325Z",
    fill: "#F4A28C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0927 25L81.8702 25.4236C81.9178 25.447 81.9545 25.4779 81.9765 25.513C81.9986 25.5481 82.0053 25.5861 81.9959 25.6233C81.9864 25.6605 81.9613 25.6955 81.9229 25.7248C81.8846 25.754 81.8344 25.7764 81.7775 25.7898L81 26L81.0927 25Z",
    fill: "#F4A28C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 27L75.5217 24.3628C75.5217 24.3628 73.6442 24.269 74.0601 23.1875C74.4761 22.1059 75.3079 22.6936 75.1808 21.5331C75.0537 20.3725 76.1455 20.0021 77.0294 20.5898C77.9132 21.1775 77.4222 20.2886 78.3984 20.0663C79.3747 19.8441 79.6867 20.1997 79.7906 20.8417C79.8946 21.4837 81.2406 20.6639 81.7143 21.4442C82.188 22.2245 82.3555 22.9949 79.8946 23.3751C77.4337 23.7554 79.4671 25.2962 76.7174 27Z",
    fill: "#FFD200"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25.4784C78 25.4784 77.8209 24.8712 77.2834 25.0249C76.746 25.1787 77.0078 26.0549 77.7749 25.9973L78 25.4784Z",
    fill: "#F4A28C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M68 40.0213C68 40.0213 70.5585 44.5172 75.9292 41.3008C81.2999 38.0844 87.3103 36.3861 90.7886 40.1376L91 42.15L68.5128 45L68 40.0213Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.878 14.5504L93.4297 16.4469L93.8704 20.2774L110.318 18.3808L109.878 14.5504Z",
    fill: "#BABABA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.737 21.9947L94.2891 23.8912L94.7297 27.7217L111.178 25.8252L110.737 21.9947Z",
    fill: "#BABABA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M91.8212 46.8462L77.1875 48.5336L77.6282 52.364L92.2619 50.6767L91.8212 46.8462Z",
    fill: "#BABABA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M93.1142 58.1541L78.4805 59.8414L78.9211 63.6719L93.5549 61.9845L93.1142 58.1541Z",
    fill: "#BABABA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M120.001 43.5921L105.367 45.2794L105.808 49.1099L120.442 47.4225L120.001 43.5921Z",
    fill: "#BABABA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M121.306 54.9051L106.672 56.5924L107.113 60.4229L121.746 58.7355L121.306 54.9051Z",
    fill: "#BABABA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M120.262 28.441L95.1484 31.3368L96.3154 41.4802L121.429 38.5845L120.262 28.441Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M124.496 65.2631L72.1523 71.2986L73.8324 85.9022L126.176 79.8667L124.496 65.2631Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7387 48.0849L69.4727 48.6921L70.0792 53.9642L75.3452 53.357L74.7387 48.0849Z",
    fill: "#0D9F3F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M102.547 44.8788L97.2812 45.486L97.8878 50.7581L103.154 50.1509L102.547 44.8788Z",
    fill: "#FFD200"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0356 59.3927L70.7695 59.9999L71.376 65.272L76.6421 64.6648L76.0356 59.3927Z",
    fill: "#24285B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M103.852 56.186L98.5859 56.7932L99.1924 62.0653L104.459 61.4581L103.852 56.186Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M125.599 74.5997L109.832 76.4177L110.439 81.6898L126.206 79.8718L125.599 74.5997Z",
    fill: "#0D9F3F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.177 6.8581L112.021 5.70596C111.922 4.83002 112.175 3.95058 112.727 3.26016C113.279 2.56975 114.083 2.12462 114.965 2.02222C115.401 1.97182 115.843 2.00736 116.266 2.12682C116.689 2.24627 117.083 2.44729 117.428 2.71838C117.772 2.98948 118.059 3.32533 118.273 3.70676C118.487 4.08818 118.622 4.50769 118.673 4.94131L119.983 16.2664C120.021 16.5863 119.995 16.9106 119.906 17.2204C119.817 17.5303 119.668 17.8198 119.467 18.0722C119.265 18.3247 119.016 18.5352 118.732 18.6916C118.449 18.8481 118.137 18.9474 117.815 18.984C117.164 19.0581 116.511 18.8729 115.998 18.469C115.485 18.065 115.155 17.4754 115.079 16.8295L114.372 10.733",
    stroke: "#24285B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyResult);
export default __webpack_public_path__ + "static/media/empty-result.a88a42cd10f3509273bb11f4c32498c7.svg";
export { ForwardRef as ReactComponent };